import { render, staticRenderFns } from "./DispatchNotes.vue?vue&type=template&id=5e163bdf&"
import script from "./DispatchNotes.vue?vue&type=script&lang=js&"
export * from "./DispatchNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports